module.exports = __webpack_public_path__ + "static/img/peo06@2x.0eaa90fa.png";